import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../../../action';

function Breakdown({
  landTransactionList
}) {

  const setModal = useContext(ModalContext);

  useEffect(() => {
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <div className="col-12">
        <table className="transaction-table table table-borderless table-sm table-striped table-hover">
          <thead>
            <tr>
              <th>Year</th>
              <th>Qtr</th>
              <th>Rate</th>
              <th>Assessed Value</th>
              <th>Amount</th>
              <th>Penalty</th>
              <th>Discount</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {landTransactionList &&
            landTransactionList.length <= 0 && (
              <tr className="text-center">
                <td colSpan="7">No data</td>
              </tr>
            )}
            {landTransactionList &&
              landTransactionList.attributes.breakdowns.map(item => (
                <tr key={item.id}>
                  <td>{_.get(item, 'year') || ''}</td>
                  <td>{_.get(item, 'qtr') || ''}</td>
                  <td>{_.get(item, 'rate_name') || '' || ''}</td>
                  <td>{_.get(item, 'assessed_value_human') || ''}</td>
                  <td>{_.get(item, 'amount_human') || ''}</td>
                  <td>{_.get(item, 'penalty_human') || ''}</td>
                  <td>{_.get(item, 'discount_human') || ''}</td>
                  <td>{_.get(item, 'total_amount_human') || ''}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-center">
        <button
          type="button"
          onClick={closeModal}
          className="mt-3 btn btn-dark "
        >
          <span className="font-weight-bold">Close</span>
        </button>
      </div>
    </Modal.Body>
  );
}

Breakdown.propTypes = {
  landTransactionList: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(Breakdown);
